var map = {
	"./add.svg": "1ede",
	"./again.svg": "c9b8",
	"./grade.svg": "1e34",
	"./green_add.svg": "22da",
	"./next.svg": "26f6",
	"./order.svg": "dc46",
	"./ordered.svg": "09d5",
	"./original.svg": "133c",
	"./play.svg": "54c1",
	"./playing1.svg": "e09f",
	"./playing2.svg": "12ee",
	"./reduce.svg": "697e",
	"./refresh.svg": "f77f",
	"./search.svg": "9686",
	"./top.svg": "c772"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c1ce";